/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface UpdateTeamMemberAvailability {
  id?: string | null;
  startDate: string;
  endDate?: string | null;
  title?: UpdateTeamMemberAvailabilityTitleEnum | null;
  description?: string | null;
}
export enum UpdateTeamMemberAvailabilityTitleEnum {
  Terminated = 'Terminated',
  Dormant = 'Dormant',
  Active = 'Active',
  Other = 'Other'
}
